<template>
    <div class="Data">
    <section>
        
        <div class="xboards-grid">
        
        <router-link class="card board columns" :to="`/datasets/${dataset.id}/`" 
          v-for="dataset in datasets"
          :key="dataset.id">
          <div class="card-content column" >
            <div class="content">
                
                <p class="title is-4">{{ dataset.name }}</p>
              
              <p class="subtitle is-6">
                {{ dataset.description }}
              </p>
              <p class="subtitle is-6">
                Created at {{ dataset["createdAt"].toDate() }}
                </p>
              <p class="subtitle is-6">
                <b-tag type="is-secondary" v-if="dataset.public">
                  public
                </b-tag>
                <b-tag type="is-secondary">
                  instances {{ dataset.instances }}
                </b-tag>
                <b-tag type="is-secondary">
                  tokens {{ dataset.tokens }}
                </b-tag>
                <b-tag type="is-secondary" v-if="dataset.label_score">
                  quality score {{ dataset.label_score.toFixed(3)*1000 }}/1000
                </b-tag>
              </p>
            </div>
          </div>
        </router-link>

      </div>

        <!--div v-for="dataset in datasets" :key="dataset.id" class="columns">
            <div class="column">
                <div class="card">
                    <div class="card-content">
                        <p class="title is-5">
                        
                        <b-button
                        tag="router-link"
                        :to="'/datasets/'+ dataset.id"
                        :label="dataset.name"
                        
                        size="is-large"/>

                        </p>
                        <p class="subtitle is-6">
                        Created at {{ new Date(dataset["createdAt"] * 1000) }}
                        </p>
                        <p class="subtitle is-4">
                        {{ dataset["tokens"] }} tokens and 
                        {{ dataset["instances"] }} instances
                        </p>
                    </div>
                </div>
            </div>
        </div-->

    </section>

    </div>
</template>
<script>
import Papa from 'papaparse';

   export default {
     props: ["modelId","model"],
     name: "Data",
     data: function() {
    return {
        csv: null,
        label_col: null,
        text_col: null,
       animated: true,
       imageData: null,
       file2: null,
      picture: null,
      files: [],
      uploadValue: 0,
      csv: 1,
      json: 1,
      previewDataset: null,
      isComponentModalActive: false,
      isComponentDatasetEditActive: false,
        formProps: {
            email: 'evan@you.com',
            password: 'testing'
        }
    }},
    components: {
    },
    methods: {
        searchIds(toSearch, Ids) {
            Ids = new Set(Ids)
            return toSearch.filter(({id}) => Ids.has(id))
        }
    },
     computed: {
       datasets() {
         let datasets = [...this.$store.state.datasets, ...this.$store.state.publicDatasets]
         var filteredDatasets = this.searchIds(datasets, this.model.datasets)
         return filteredDatasets
       },

     },
     created() {

       this.$store.dispatch("retrieveAllDatasets");
       this.$store.dispatch("retrievePublicDatasets");

       // this.listFiles()
       //this.$store.dispatch("displayModelDetails", this.boardId);
       //this.listFiles()
       
       this.training = true
       this.options = {}
       // this.series = [44, 55, 41, 17, 15]
     }
   };
</script>


<style lang="scss" scoped>
.boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;

  .board {
    cursor: pointer;
    border: solid 1px #e6e4e4;
    border-radius: 4px;

    &:hover {
      background: #fafafa;
    }

    .info {
      padding: 16px;

      .name {
        display: block;
        margin-bottom: 8px;
        text-transform: capitalize;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .description {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin: 0;
        margin-bottom: 8px;
        overflow: hidden;
      }
    }
  }
}
</style>